import { combineReducers } from 'redux'
import misc from './misc'
import employee from './employee'

export default combineReducers({
  misc,
  employee,
})
